import { ShieldAlert } from 'lucide-react';

export default function ErrorAlert({ message }) {
  if (!message) return null;
  
  return (
    <div className="p-4 text-sm rounded-xl bg-red-50 text-red-600 dark:bg-red-900/30 dark:text-red-400 border border-red-200 dark:border-red-800/50 flex items-center gap-3">
      <ShieldAlert size={18} className="flex-shrink-0" />
      <p>{message}</p>
    </div>
  );
}
